function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import ReactDOM from 'react-dom';
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group' // ES6
import TransitionGroup from 'react-transition-group/TransitionGroup';
import CSSTransition from 'react-transition-group/CSSTransition';

import FlipMove from 'react-flip-move';

var SCROLL_MARGIN = 50;
var MAX_SCROLL_SPEED = 30;
var SCROLL_ACCELERATION = 1.02;
var INITIAL_SCROLL_SPEED = 2;

function square(x) {
    return x * x;
}
function distSquared(v, w) {
    return square(v.x - w.x) + square(v.y - w.y);
}
function distToSegmentSquared(p, v, w) {
    var l2 = distSquared(v, w);
    if (l2 == 0) return distSquared(p, v);
    var t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
    t = Math.max(0, Math.min(1, t));
    return distSquared(p, { x: v.x + t * (w.x - v.x),
        y: v.y + t * (w.y - v.y) });
}
function distToSegment(p, v, w) {
    return Math.sqrt(distToSegmentSquared(p, v, w));
}

function uuid() {
    return Math.random().toString(36).slice(5, 10);
}

function computeLines(el) {
    var rows = el.querySelectorAll('.real-bread-row');
    var lines = [];
    for (var i = 0; i < rows.length; i++) {
        var rect = rows[i].getBoundingClientRect();
        if (i === 0) {
            lines.push({
                x0: rect.left, x1: rect.right,
                y0: rect.top, y1: rect.top,
                pos: 'top-' + i
            });
        }
        lines.push({
            x0: rect.left, x1: rect.right,
            y0: rect.bottom, y1: rect.bottom,
            pos: 'bottom-' + i
        });

        var slices = rows[i].querySelectorAll('.bread-col');
        for (var j = 0; j < slices.length; j++) {
            var rect = slices[j].getBoundingClientRect();
            if (j === 0) {
                lines.push({
                    x0: rect.left, x1: rect.left,
                    y0: rect.top, y1: rect.bottom,
                    pos: 'left-' + i + '-' + j
                });
            }
            lines.push({
                x0: rect.right, x1: rect.right,
                y0: rect.top, y1: rect.bottom,
                pos: 'right-' + i + '-' + j
            });
        }
    }
    return lines;
}

function getRect(el, i, j) {
    var rows = el.querySelectorAll('.real-bread-row');
    var slices = rows[i].querySelectorAll('.bread-col');
    var rect = slices[j].getBoundingClientRect();
    return rect;
}

function locateKey(layout, id) {
    for (var i = 0; i < layout.length; i++) {
        var items = layout[i].items;
        for (var j = 0; j < items.length; j++) {
            if (items[j].id === id) {
                return [i, j];
            }
        }
    }
}

var BreadLoaf = function (_React$Component) {
    _inherits(BreadLoaf, _React$Component);

    function BreadLoaf() {
        _classCallCheck(this, BreadLoaf);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this));

        _this.state = { dragObject: null, dockTarget: null, layout: [] };
        _this.onDrag = _this.onDrag.bind(_this);
        _this.endDrag = _this.endDrag.bind(_this);
        return _this;
    }

    BreadLoaf.prototype.beginDrag = function beginDrag(thing, e) {
        this.setState({ dragObject: thing });
        window.addEventListener('mousemove', this.onDrag);
        window.addEventListener('mouseup', this.endDrag);
        requestAnimationFrame(this.dragScroll.bind(this));
    };

    BreadLoaf.prototype.dragScroll = function dragScroll() {
        if (!this.state.dragObject) return;

        if (this.shouldScroll) {
            window.scrollBy(0, this.shouldScroll);

            if (this.shouldScroll < 0) {
                this.shouldScroll = this.shouldScroll < 0 ? Math.max(-MAX_SCROLL_SPEED, this.shouldScroll * SCROLL_ACCELERATION) : -INITIAL_SCROLL_SPEED;
            } else if (this.shouldScroll > 0) {
                this.shouldScroll = this.shouldScroll > 0 ? Math.min(MAX_SCROLL_SPEED, this.shouldScroll * SCROLL_ACCELERATION) : INITIAL_SCROLL_SPEED;
            }
        }

        requestAnimationFrame(this.dragScroll.bind(this));
    };

    BreadLoaf.prototype.onDrag = function onDrag(e) {
        if (!this.state.dragObject) return;

        e.preventDefault();

        var clientY = e.clientY;
        var el = ReactDOM.findDOMNode(this);

        var pos = this.state.dragObject.split('-');
        var thingRect = getRect(el, pos[0], pos[1]);
        var lines = computeLines(el);

        lines.forEach(function (k) {
            return k.dist = distToSegment({ x: e.clientX, y: e.clientY }, { x: k.x0, y: k.y0 }, { x: k.x1, y: k.y1 });
        });

        var closestPos = lines.sort(function (a, b) {
            return a.dist - b.dist;
        })[0].pos;

        if (e.clientY < SCROLL_MARGIN) {
            this.shouldScroll = this.shouldScroll < 0 ? Math.max(-MAX_SCROLL_SPEED, this.shouldScroll * SCROLL_ACCELERATION) : -INITIAL_SCROLL_SPEED;
        } else if (e.clientY > innerHeight - SCROLL_MARGIN) {
            this.shouldScroll = this.shouldScroll > 0 ? Math.min(MAX_SCROLL_SPEED, this.shouldScroll * SCROLL_ACCELERATION) : INITIAL_SCROLL_SPEED;
        } else {
            this.shouldScroll = false;
        }

        if (e.clientX > thingRect.left && e.clientX < thingRect.right && e.clientY > thingRect.top && e.clientY < thingRect.bottom) {

            if (e.clientX > thingRect.left / 2 + thingRect.right / 2) {
                closestPos = 'right-' + [pos[0], pos[1]].join('-');
            } else {
                closestPos = +pos[1] == 0 ? 'left-' + pos.join('-') : 'right-' + [pos[0], pos[1] - 1].join('-');
            }
        }

        if (this.state.dockTarget !== closestPos) this.setState({ dockTarget: closestPos });
    };

    BreadLoaf.prototype.cloneLayout = function cloneLayout() {
        return this.getLayout().map(function (row) {
            return { rowId: row.rowId, items: row.items.slice(0) };
        });
    };

    BreadLoaf.prototype.updateLayout = function updateLayout(data) {
        data = data.filter(function (k) {
            return k.items.length > 0;
        });
        if (this.props.layout) {
            var _props;

            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            (_props = this.props).updateLayout.apply(_props, [data].concat(args));
        } else {
            this.setState({ layout: data });
        }
    };

    BreadLoaf.prototype.getLayout = function getLayout() {
        if (this.props.layout) {
            return this.props.layout;
        } else {
            return this.state.layout;
        }
    };

    BreadLoaf.prototype.makeSlice = function makeSlice() {
        var basis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (this.props.makeSlice) {
            basis = this.props.makeSlice();
        }
        return basis;
    };

    BreadLoaf.prototype.makeRowID = function makeRowID() {
        if (this.props.makeRowID) return this.props.makeRowID();
        return 'r' + uuid();
    };

    BreadLoaf.prototype.makeSliceID = function makeSliceID() {
        if (this.props.makeSliceID) return this.props.makeSliceID();
        return 's' + uuid();
    };

    BreadLoaf.prototype.append = function append(item) {
        if (!item.id) item.id = uuid();

        this.updateLayout(this.getLayout().concat([{
            rowId: this.makeRowID(),
            items: [item]
        }]), 'append', item);
    };

    BreadLoaf.prototype.prepend = function prepend(item) {
        if (!item.id) item.id = uuid();

        this.updateLayout([{
            rowId: this.makeRowID(),
            items: [item]
        }].concat(this.getLayout()), 'prepend', item);
    };

    BreadLoaf.prototype.endDrag = function endDrag(e) {
        if (this.state.dockTarget && this.state.dragObject) {
            var pos = this.state.dockTarget.split('-');
            var thing = this.state.dragObject.split('-');
            var nextRows = this.cloneLayout();
            var anchor = pos[0];
            var i = +thing[0],
                j = +thing[1];

            if (anchor === 'top' || anchor === 'bottom') {
                if (!e.altKey && nextRows[i].items.length == 1 && (anchor === 'top' && i === +pos[1] || anchor === 'bottom' && i === parseInt(pos[1]) + 1 || anchor === 'bottom' && i === +pos[1])) {
                    // console.log('noop', anchor, thing, pos)
                } else {
                    if (e.altKey) {
                        // don't remove the old one, just make a copy
                        var oldThing = Object.assign({}, nextRows[i].items[j], { id: this.makeSliceID() });
                    } else {
                        var oldThing = nextRows[i].items.splice(j, 1)[0];
                    }

                    var newRow = { rowId: this.makeRowID(), items: [oldThing] };
                    if (anchor === 'top') {
                        nextRows.splice(+pos[1], 0, newRow);
                    } else {
                        nextRows.splice(1 + parseInt(pos[1]), 0, newRow);
                    }
                }
            } else if (anchor === 'left' || anchor === 'right') {
                if (e.altKey) {
                    // don't remove the old one, just make a copy
                    var oldThing = Object.assign({}, nextRows[i].items[j], { id: this.makeSliceID() });
                } else {
                    // swap it with null
                    var oldThing = nextRows[i].items.splice(j, 1, null)[0];
                }
                if (anchor === 'left') {
                    nextRows[+pos[1]].items.splice(+pos[2], 0, oldThing);
                } else {
                    nextRows[+pos[1]].items.splice(1 + parseInt(pos[2]), 0, oldThing);
                }
                // actually remove the thing
                nextRows[i].items = nextRows[i].items.filter(function (k) {
                    return k !== null;
                });
            }
            this.updateLayout(nextRows, 'drag', oldThing);
        }
        this.setState({ dragObject: null, dockTarget: null });
        window.removeEventListener('mousemove', this.onDrag);
        window.removeEventListener('mouseup', this.endDrag);
    };

    BreadLoaf.prototype.makeElement = function makeElement(data, pos) {
        var _this2 = this;

        return React.cloneElement(this.props.element, {
            isDragging: this.state.dragObject === pos,
            view: data,
            layout: this.getLayout(),
            updateView: function updateView(d) {
                var newRows = _this2.cloneLayout();

                var _locateKey = locateKey(newRows, data.id),
                    rowi = _locateKey[0],
                    coli = _locateKey[1];

                newRows[rowi].items[coli] = Object.assign({}, data, d);
                _this2.updateLayout(newRows, 'update', data);
            },
            close: function close() {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                var newRows = _this2.cloneLayout();

                var _locateKey2 = locateKey(newRows, data.id),
                    rowi = _locateKey2[0],
                    coli = _locateKey2[1];

                newRows[rowi].items.splice(coli, 1);
                _this2.updateLayout.apply(_this2, [newRows, 'close', data].concat(args));
            },
            fork: function fork() {
                for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    args[_key3] = arguments[_key3];
                }

                var newRows = _this2.cloneLayout();

                var _locateKey3 = locateKey(newRows, data.id),
                    rowi = _locateKey3[0],
                    coli = _locateKey3[1];

                var newData = Object.assign({}, data, { id: _this2.makeSliceID() });
                newRows[rowi].items.splice(coli + 1, 0, newData);
                _this2.updateLayout.apply(_this2, [newRows, 'fork', newData].concat(args));
            },
            after: function after() {
                for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                    args[_key4] = arguments[_key4];
                }

                var newRows = _this2.cloneLayout();

                var _locateKey4 = locateKey(newRows, data.id),
                    rowi = _locateKey4[0],
                    coli = _locateKey4[1];

                var newData = _this2.makeSlice(); //Object.assign({}, data, { id: this.makeSliceID() });
                newRows.splice(rowi + 1, 0, { rowId: _this2.makeRowID(), items: [newData] });
                _this2.updateLayout.apply(_this2, [newRows, 'insert', newData].concat(args));
            },
            before: function before() {
                for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                    args[_key5] = arguments[_key5];
                }

                var newRows = _this2.cloneLayout();

                var _locateKey5 = locateKey(newRows, data.id),
                    rowi = _locateKey5[0],
                    coli = _locateKey5[1];

                var newData = _this2.makeSlice(); //Object.assign({}, data, { id: this.makeSliceID() });
                newRows.splice(rowi, 0, { rowId: _this2.makeRowID(), items: [newData] });
                _this2.updateLayout.apply(_this2, [newRows, 'insert', newData].concat(args));
            },
            beginDrag: function beginDrag(e) {
                var _locateKey6 = locateKey(_this2.getLayout(), data.id),
                    rowi = _locateKey6[0],
                    coli = _locateKey6[1];

                _this2.beginDrag(rowi + '-' + coli, e);
            }
        });
    };

    BreadLoaf.prototype.render = function render() {
        var _this3 = this;

        return React.createElement(
            'div',
            { className: 'bread', style: { cursor: this.state.dragObject ? 'move' : 'default' } },
            React.createElement(
                FlipMove,
                { onStart: function onStart(childElement, domNode) {
                        domNode.classList.add('flip-move-animating');
                        // if(childElement.onMoveStart) childElement.onMoveStart();
                    }, onFinish: function onFinish(childElement, domNode) {
                        domNode.classList.remove('flip-move-animating');
                        // if(childElement.onMoveFinish) childElement.onMoveFinish();
                    }, onFinishAll: function onFinishAll(childElements, domNodes) {
                        _this3.props.onMoved && _this3.props.onMoved(domNodes);
                    } },
                this.props.header || null,
                React.createElement(
                    'div',
                    { className: "bread-row " + ((this.state.dockTarget === 'top-0' ? 'insert-top ' : '') + 'row-1'), key: "toprow" },
                    React.createElement('div', { className: 'divider divider-top', onClick: function onClick(d) {
                            var newRows = _this3.cloneLayout();
                            // let rowi = newRows.findIndex(k => k.rowId == row.rowId)
                            var rowi = 0;
                            var divRect = d.target.getBoundingClientRect();
                            var data = newRows[rowi] && newRows[rowi].items[Math.floor(newRows[rowi].items.length * (d.clientX - divRect.left) / divRect.right)];
                            var item = Object.assign({}, d.altKey ? data : _this3.makeSlice(), { id: _this3.makeSliceID() });
                            newRows.splice(rowi, 0, { rowId: _this3.makeRowID(), items: [item] });
                            _this3.updateLayout(newRows, 'insert', item);
                        } })
                ),
                this.getLayout().map(function (row, rowi) {
                    return React.createElement(
                        'div',
                        { className: "bread-row real-bread-row " + ((_this3.state.dockTarget === 'bottom-' + rowi ? 'insert-bottom ' : '') + (row.items.length > 1 ? '' : 'row-1')), key: row.rowId },
                        React.createElement(
                            TransitionGroup,
                            null,
                            row.items.map(function (data, coli) {
                                return React.createElement(
                                    CSSTransition,
                                    {
                                        classNames: 'bread',
                                        timeout: 300,
                                        key: data.id,
                                        onEntered: function onEntered(node) {
                                            return _this3.props.onMoved && _this3.props.onMoved(node);
                                        },
                                        onExited: function onExited(node) {
                                            return _this3.props.onMoved && _this3.props.onMoved(node);
                                        } },
                                    React.createElement(
                                        'div',
                                        { className: "bread-col " + ((_this3.state.dragObject === rowi + '-' + coli ? 'dragging ' : '') + (_this3.state.dockTarget === 'left-' + rowi + '-' + coli ? 'insert-left ' : '') + (_this3.state.dockTarget === 'right-' + rowi + '-' + coli ? 'insert-right ' : '')) },
                                        coli == 0 && React.createElement('div', { className: 'vertical-divider divider-left', onClick: function onClick(d) {
                                                var newRows = _this3.cloneLayout();

                                                var _locateKey7 = locateKey(newRows, data.id),
                                                    rowi = _locateKey7[0],
                                                    coli = _locateKey7[1];

                                                var item = Object.assign({}, d.altKey ? data : _this3.makeSlice(), { id: _this3.makeSliceID() });
                                                newRows[rowi].items.splice(coli, 0, item);
                                                _this3.updateLayout(newRows, d.altKey ? 'fork' : 'insert', item);
                                            } }),
                                        _this3.makeElement(data, rowi + '-' + coli),
                                        React.createElement('div', { className: 'vertical-divider divider-right', onClick: function onClick(d) {
                                                var newRows = _this3.cloneLayout();

                                                var _locateKey8 = locateKey(newRows, data.id),
                                                    rowi = _locateKey8[0],
                                                    coli = _locateKey8[1];

                                                var item = Object.assign({}, d.altKey ? data : _this3.makeSlice(), { id: _this3.makeSliceID() });
                                                newRows[rowi].items.splice(coli + 1, 0, item);
                                                _this3.updateLayout(newRows, d.altKey ? 'fork' : 'insert', item);
                                            } })
                                    )
                                );
                            })
                        ),
                        React.createElement('div', { className: 'divider divider-bottom', onClick: function onClick(d) {
                                var newRows = _this3.cloneLayout();
                                var rowi = newRows.findIndex(function (k) {
                                    return k.rowId == row.rowId;
                                });

                                var divRect = d.target.getBoundingClientRect();
                                var data = newRows[rowi].items[Math.floor(newRows[rowi].items.length * (d.clientX - divRect.left) / divRect.right)];

                                var item = Object.assign({}, d.altKey ? data : _this3.makeSlice(), { id: _this3.makeSliceID() });
                                newRows.splice(rowi + 1, 0, { rowId: _this3.makeRowID(), items: [item] });
                                _this3.updateLayout(newRows, 'insert', item);
                            } })
                    );
                }),
                this.props.footer || null
            )
        );
    };

    return BreadLoaf;
}(React.Component);

export { BreadLoaf as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/breadloaf/es/index.js
// module id = P39X
// module chunks = 1